import React from 'react';
import { getBrandImage } from '../../data/brandImages';
import { HOW_IT_WORKS_STEPS } from '../../data/siteContent';
import { BrandStrip } from './ClientLayout';
import { PageHero, StepIcon } from './HomePage';

const MEMBER_STEPS = [
  {
    title: '1. Avisá que sos miembro',
    text: 'Al pedir por WhatsApp o en el local, decile al cajero tu número de teléfono o nombre para que te registren la compra.',
  },
  {
    title: '2. Sumás puntos automáticamente',
    text: 'Cada compra te acredita puntos en tu cuenta. Revisá tu saldo actualizado en "Inicio".',
  },
  {
    title: '3. Elegí y canjeá un beneficio',
    text: 'Cuando tengas puntos suficientes, entrá a "Canjes", elegí el beneficio y tocá "Usar beneficio". Seleccioná el local y confirmá.',
  },
  {
    title: '4. El cajero lo recibe solo',
    text: 'El aviso le llega directo al local. No necesitás mostrar nada — solo presentarte y disfrutar.',
  },
];

const HowItWorksPage = ({ setCurrentView, siteConfig, userProfile }) => {
  const isMember = !!userProfile;
  const steps = isMember ? MEMBER_STEPS : HOW_IT_WORKS_STEPS;

  return (
    <div>
      <PageHero
        image={getBrandImage(siteConfig, 'heroComoFunciona')}
        compact
        title={
          isMember
            ? <>Así canjeás tus <span className="text-maja-red">beneficios</span></>
            : <>Así de fácil es ser parte de Maja <span className="text-maja-red">Club</span></>
        }
        subtitle={
          isMember
            ? 'Todo lo que necesitás saber para usar tus puntos.'
            : 'Sumá, canjeá y viví todo el sabor de Maja Morena.'
        }
        scripts={isMember ? ['Tus puntos, tus reglas'] : ['Un club hecho para vos', 'Más rico pertenecer']}
      />

        <section className="py-14" style={{ background: 'linear-gradient(180deg, #fff 0%, #fdf2f2 100%)' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-12">
            <p className="text-xs font-black uppercase tracking-widest text-maja-red mb-2">Club Maja</p>
            <h2 className="text-3xl font-black text-gray-900">
              {isMember ? 'Así usás tus puntos' : 'Así de fácil es empezar'}
            </h2>
          </div>

          {/* Tarjetas de pasos */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 relative">
            {steps.map((step, i) => {
              const ICONS = ['🗣️', '⭐', '🎁', '✅']
              const COLORS = [
                { bg: '#fff1f1', border: '#fecaca', badge: '#E30613' },
                { bg: '#fff7ed', border: '#fed7aa', badge: '#ea580c' },
                { bg: '#fefce8', border: '#fef08a', badge: '#ca8a04' },
                { bg: '#f0fdf4', border: '#bbf7d0', badge: '#16a34a' },
              ]
              const c = COLORS[i]
              return (
                <div key={step.title} className="relative">
                  <div
                    className="rounded-2xl p-6 h-full flex flex-col"
                    style={{ background: c.bg, border: `1.5px solid ${c.border}` }}
                  >
                    {/* Ícono + número */}
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-3xl">{ICONS[i]}</span>
                      <span
                        className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-black text-white shrink-0"
                        style={{ background: c.badge }}
                      >
                        {i + 1}
                      </span>
                    </div>
                    <h3 className="font-black text-gray-900 text-base leading-snug mb-2">
                      {step.title.replace(/^\d+\.\s/, '')}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed flex-1">{step.text}</p>
                  </div>

                  {/* Flecha conectora */}
                  {i < steps.length - 1 && (
                    <div className="hidden lg:flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white shadow items-center justify-center"
                      style={{ border: '1.5px solid #f3f4f6' }}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8h10M9 4l4 4-4 4" stroke="#E30613" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  )}
                </div>
              )
            })}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => setCurrentView(isMember ? 'canjes' : 'registration')}
              className="h-12 px-8 rounded-full bg-maja-red text-white font-black shadow-lg"
            >
              {isMember ? 'Ver beneficios disponibles →' : 'Quiero sumarme gratis →'}
            </button>
            {isMember && (
              <button
                onClick={() => setCurrentView('help')}
                className="h-12 px-8 rounded-full border border-gray-200 bg-white text-gray-600 font-black text-sm"
              >
                ¿Tenés dudas? Ayuda →
              </button>
            )}
            {!isMember && (
              <p className="font-script text-maja-red text-2xl">Más rico pertenecer</p>
            )}
          </div>

        </div>
      </section>

        {/* ── Sección de niveles y fidelidad ── */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">

        {/* Mensaje de fidelidad */}
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <p className="text-xs font-black uppercase tracking-widest text-maja-red mb-3">Tu fidelidad tiene recompensa</p>
          <h2 className="text-3xl font-black text-gray-900 mb-4">Cada compra te acerca a más</h2>
          <p className="text-gray-500 leading-relaxed">
            En Maja Morena creemos que los clientes que nos eligen merecen algo especial.
            Por eso cada vez que comprás, sumás puntos que te hacen subir de nivel —
            y cuanto más alto el nivel, más beneficios exclusivos te esperan.
          </p>
        </div>

        {/* Escala de niveles */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-12">
          {[
            {
              key: 'bronce', icon: '🥉', label: 'Bronce',
              range: '0 – 999 pts', color: '#b45309', bg: '#fef3c7', border: '#fde68a',
              perks: ['Beneficios de bienvenida', 'Descuentos en productos seleccionados', 'Acceso al catálogo de canjes'],
              ejemplo: 'Llegás acá desde tu primera compra.',
            },
            {
              key: 'plata', icon: '🥈', label: 'Plata',
              range: '1.000 – 2.999 pts', color: '#475569', bg: '#f1f5f9', border: '#cbd5e1',
              perks: ['Todo lo de Bronce', 'Beneficios exclusivos Plata', 'Prioridad en promociones'],
              ejemplo: 'Con ~10 pedidos ya subís a Plata.',
            },
            {
              key: 'oro', icon: '🥇', label: 'Oro',
              range: '3.000 pts en adelante', color: '#b45309', bg: '#fffbeb', border: '#fcd34d',
              perks: ['Todo lo de Plata', 'Beneficios premium exclusivos', 'Sorpresas y reconocimientos especiales'],
              ejemplo: 'El nivel más alto. La élite Maja.',
              destacado: true,
            },
          ].map(({ icon, label, range, color, bg, border, perks, ejemplo, destacado }) => (
            <div key={label}
              className="rounded-2xl p-6 flex flex-col relative overflow-hidden"
              style={{ background: bg, border: `2px solid ${border}` }}
            >
              {destacado && (
                <div className="absolute top-3 right-3 text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full"
                  style={{ background: color, color: '#fff' }}>
                  Nivel máximo
                </div>
              )}
              <div className="text-4xl mb-3">{icon}</div>
              <p className="font-black text-xl mb-0.5" style={{ color }}>{label}</p>
              <p className="text-xs font-semibold text-gray-400 mb-4">{range}</p>
              <ul className="space-y-1.5 mb-4 flex-1">
                {perks.map(p => (
                  <li key={p} className="flex items-start gap-2 text-sm text-gray-600">
                    <span className="mt-0.5 text-green-500 font-black shrink-0">✓</span>
                    {p}
                  </li>
                ))}
              </ul>
              <p className="text-xs text-gray-400 italic border-t pt-3" style={{ borderColor: border }}>{ejemplo}</p>
            </div>
          ))}
        </div>

        {/* Ejemplo concreto */}
        <div className="rounded-2xl bg-maja-red p-8 text-white text-center">
          <p className="text-xs font-black uppercase tracking-widest mb-3 opacity-70">Un ejemplo real</p>
          <p className="text-xl font-black leading-snug mb-2">
            Con un pedido de <span className="underline underline-offset-4">$5.000</span> ya sumás <span className="underline underline-offset-4">50 puntos</span>.
          </p>
          <p className="text-white/70 text-sm leading-relaxed max-w-lg mx-auto">
            En unas pocas compras llegás a Plata, y con constancia alcanzás el nivel Oro —
            donde Maja te reconoce como parte de su comunidad más fiel con beneficios que no encontrás en otro lado.
          </p>
        </div>

      </section>

      <BrandStrip
        setCurrentView={setCurrentView}
        title={
          isMember
            ? 'Revisá todos los beneficios disponibles y empezá a canjear.'
            : 'Sumá puntos. Viví experiencias. Formá parte de algo más grande.'
        }
        cta={isMember ? 'Ver canjes' : 'Conocer beneficios'}
        target={isMember ? 'canjes' : 'benefits'}
      />
    </div>
  );
};

export default HowItWorksPage;
